export default "__VITE_ASSET__B2il8lQK__"